var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.54 62.212 l 5.913 11.075 c -0.772 1.458 -1.273 3.474 -1.273 5.124 v 5.077 c 0 1.778 -1.441 3.219 -3.219 3.219 H 22.175 c -1.778 0 -3.219 -1.441 -3.219 -3.219 v -1.826 c 0 -1.492 -0.595 -2.922 -1.652 -3.973 l -5.134 -5.107 c -4.259 -4.237 -7.117 -9.678 -8.187 -15.589 l -2.479 -18.2 c -0.215 -1.187 0.792 -2.24 1.987 -2.077 C 14.407 40.483 24.609 50.218 34.54 62.212 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(227,197,164)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 86.509 36.716 c 1.195 -0.163 2.202 0.89 1.987 2.077 l -2.479 18.2 c -1.071 5.911 -3.928 11.352 -8.187 15.589 l -5.134 5.107 c -1.057 1.052 -1.652 2.482 -1.652 3.973 v 1.826 c 0 1.778 -1.441 3.219 -3.219 3.219 H 54.039 c -1.778 0 -3.219 -1.441 -3.219 -3.219 v -5.077 c 0 -1.65 -0.465 -3.521 -1.237 -4.979 l 7.773 -14.784 C 67.224 47.819 76.974 39.748 86.509 36.716 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(227,197,164)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 85.429 36.967 c 5.575 -8.433 4.65 -19.897 -2.776 -27.323 v 0 c -8.483 -8.483 -22.237 -8.483 -30.72 0 l -4.702 4.702 c -1.232 1.232 -3.229 1.232 -4.46 0 l -4.702 -4.702 c -8.483 -8.483 -22.237 -8.483 -30.72 0 v 0 c -7.423 7.423 -8.351 18.881 -2.784 27.312 l 7.274 7.898 l 2.442 2.442 l 28.628 28.628 c 1.155 1.155 3.029 1.155 4.184 0 L 75.72 47.296 l 0 0 l 2.446 -2.446 L 85.429 36.967 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(221,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 87.306 35.773 c 4.696 -8.724 3.174 -19.716 -3.946 -26.836 c -8.861 -8.86 -23.275 -8.858 -32.135 0 l -4.702 4.702 c -0.84 0.839 -2.206 0.839 -3.046 0 l -4.702 -4.702 c -8.859 -8.858 -23.274 -8.859 -32.134 0 c -7.119 7.119 -8.643 18.113 -3.947 26.836 c -0.543 0.111 -1.048 0.366 -1.448 0.783 c -0.622 0.65 -0.887 1.53 -0.734 2.371 L 2.999 57.17 c 1.113 6.144 4.04 11.718 8.466 16.121 l 5.134 5.107 c 0.863 0.859 1.357 2.049 1.357 3.265 v 1.826 c 0 2.327 1.893 4.219 4.219 4.219 h 13.786 c 2.326 0 4.219 -1.892 4.219 -4.219 v -5.077 c 0 -1.096 0.203 -2.188 0.589 -3.212 l 1.432 1.432 c 0.772 0.772 1.785 1.158 2.799 1.158 c 1.014 0 2.028 -0.386 2.8 -1.158 l 1.441 -1.441 c 0.36 1.046 0.579 2.192 0.579 3.221 v 5.077 c 0 2.327 1.892 4.219 4.219 4.219 h 13.786 c 2.327 0 4.219 -1.892 4.219 -4.219 v -1.826 c 0 -1.216 0.494 -2.406 1.357 -3.265 l 5.135 -5.107 c 4.426 -4.403 7.354 -9.977 8.474 -16.164 l 2.472 -18.157 c 0.16 -0.885 -0.105 -1.765 -0.728 -2.415 C 88.353 36.138 87.849 35.883 87.306 35.773 z M 38.179 78.412 v 5.077 c 0 1.223 -0.995 2.219 -2.218 2.219 H 22.175 c -1.223 0 -2.218 -0.995 -2.218 -2.219 v -1.826 c 0 -1.745 -0.71 -3.451 -1.947 -4.683 l -5.134 -5.107 c -4.134 -4.113 -6.869 -9.32 -7.902 -15.015 L 2.488 38.614 c -0.044 -0.247 0.029 -0.493 0.204 -0.675 c 0.174 -0.181 0.417 -0.264 0.664 -0.232 c 5.462 0.746 9.945 10.744 10.967 19.579 c 0.048 0.418 0.354 0.762 0.764 0.859 c 4.69 1.103 8.373 4.343 9.459 6.831 c 0.22 0.506 0.809 0.738 1.317 0.518 c 0.506 -0.221 0.738 -0.811 0.517 -1.317 c -1.255 -2.88 -5.107 -6.4 -10.155 -7.805 c -0.328 -2.47 -0.9 -4.991 -1.674 -7.39 l 24.706 24.707 C 38.562 75.163 38.179 76.781 38.179 78.412 z M 46.385 75.217 c -0.764 0.762 -2.007 0.762 -2.77 0 l -30.939 -30.94 c -1.906 -3.901 -4.44 -6.952 -7.415 -8.103 c -5.223 -8.141 -4.073 -18.957 2.794 -25.824 c 8.08 -8.079 21.226 -8.078 29.305 0 l 4.702 4.702 c 1.62 1.62 4.255 1.62 5.875 0 l 4.702 -4.702 c 8.08 -8.078 21.226 -8.079 29.306 0 c 6.868 6.868 8.018 17.682 2.794 25.824 c -2.975 1.15 -5.509 4.201 -7.415 8.103 L 46.385 75.217 z M 85.033 56.814 c -1.039 5.739 -3.774 10.946 -7.908 15.059 l -5.135 5.107 c -1.238 1.232 -1.947 2.938 -1.947 4.683 v 1.826 c 0 1.223 -0.995 2.219 -2.219 2.219 H 54.039 c -1.223 0 -2.219 -0.995 -2.219 -2.219 v -5.077 c 0 -1.565 -0.395 -3.281 -1.044 -4.757 l 24.673 -24.674 c -0.774 2.399 -1.346 4.92 -1.674 7.39 c -5.049 1.406 -8.899 4.926 -10.155 7.805 c -0.221 0.506 0.011 1.096 0.518 1.317 c 0.509 0.222 1.096 -0.012 1.317 -0.518 c 1.084 -2.488 4.768 -5.728 9.458 -6.831 c 0.41 -0.097 0.716 -0.441 0.764 -0.859 c 1.022 -8.835 5.506 -18.832 10.968 -19.579 c 0.246 -0.035 0.489 0.051 0.663 0.232 c 0.174 0.182 0.248 0.427 0.196 0.718 L 85.033 56.814 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.6b9bc7173214e9dbb5ce9e5e41007161.svg";
export { ForwardRef as ReactComponent };